import { Option } from "../../types/option";

export const serviceTypes: Option[] = [
  {
    label: 'Customers can come to me. (Home Studio)',
    value: 'offersHome',
  },
  {
    label: 'I can visit customers. (Mobile)',
    value: 'offersMobile',
  },
]